<template>
    <div id="conferencedetail">
        <div class="pdf" v-show="MediaType == 'pdf'">
            <div class="top">
                <h2 v-if="MediaPDF.Number">{{MediaPDF.Number}}</h2>
                <div class="title">
                    <span class="back" @click="back">◀</span>
                    <span class="name">{{MediaPDF.Title}}</span>
                    <span class="date">{{$moment(MediaPDF.PublishOn).format("YYYY-MM-DD")}}</span>
                </div>
            </div>
            <div id="mybook" v-if="showStyle"></div>
            <iframe
                :src="`https://docs.google.com/viewer?url=${MediaPDF.DocumentFile}&embedded=true`"
                width="100%"
                height="calc(100vh - 75px)"
                style="width: 100%; height: calc(100vh - 75px);"
                frameborder="0"
                scrolling="yes"
                v-if="!showStyle"
            ></iframe>
        </div>
        <Banner
            title="會刊及影音"
            :breadcrumbs="breadcrumbs"
            type="information"
            v-show="MediaType == 'video'"
        ></Banner>
        <div class="video_container container" v-show="MediaType == 'video'">
            <div class="video_box">
                <div
                    class="date"
                    v-if="MediaVIDEO.PublishOn"
                >刊登日期 : {{$moment(MediaVIDEO.PublishOn).format("YYYY-MM-DD")}}</div>
                <div class="title">{{MediaVIDEO.Title}}</div>
                <div class="video">
                    <video
                        :src="MediaVIDEO.DocumentFile"
                        :poster="MediaVIDEO.Image"
                        controls="controls"
                        preload
                        :controlslist="islogin?'':'nodownload'"
                    ></video>
                </div>
                <div class="remark" style="white-space: pre-line;">{{MediaVIDEO.Introduction}}</div>
                <div v-if="isYoutube" class="video-container">
                <iframe
                    width="560"
                    height="315"
                    :src="videoUrl"
                    frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                ></iframe>
        </div>
                <div v-if="!isYoutube" class="download">
                    <a
                        class="Orange_btn"
                        :class="{'islogin':islogin}"
                        href="javascript:;"
                        @click="download(MediaVIDEO.DocumentFile)"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            x="0px"
                            y="0px"
                            width="18"
                            height="18"
                            viewBox="0 0 172 172"
                            style=" fill:#000000;"
                        >
                            <g
                                fill="none"
                                fill-rule="nonzero"
                                stroke="none"
                                stroke-width="1"
                                stroke-linecap="butt"
                                stroke-linejoin="miter"
                                stroke-miterlimit="10"
                                stroke-dasharray
                                stroke-dashoffset="0"
                                font-family="none"
                                font-weight="none"
                                font-size="none"
                                text-anchor="none"
                                style="mix-blend-mode: normal"
                            >
                                <path d="M0,172v-172h172v172z" fill="none" />
                                <g id="original-icon" fill="#ffffff">
                                    <g id="surface1">
                                        <path
                                            d="M86,10.32c-1.89469,0 -3.44,1.54531 -3.44,3.44c0,1.89469 1.54531,3.44 3.44,3.44c1.89469,0 3.44,-1.54531 3.44,-3.44c0,-1.89469 -1.54531,-3.44 -3.44,-3.44zM86,24.08c-1.89469,0 -3.44,1.54531 -3.44,3.44c0,1.89469 1.54531,3.44 3.44,3.44c1.89469,0 3.44,-1.54531 3.44,-3.44c0,-1.89469 -1.54531,-3.44 -3.44,-3.44zM86,37.84c-1.89469,0 -3.44,1.54531 -3.44,3.44c0,1.89469 1.54531,3.44 3.44,3.44c1.89469,0 3.44,-1.54531 3.44,-3.44c0,-1.89469 -1.54531,-3.44 -3.44,-3.44zM85.6775,51.4925c-0.14781,0.02688 -0.29562,0.06719 -0.43,0.1075c-1.59906,0.36281 -2.72781,1.80063 -2.6875,3.44v74.175l-21.6075,-21.6075c-0.83312,-0.86 -2.05594,-1.22281 -3.225,-0.9675c-1.29,0.22844 -2.32469,1.16906 -2.6875,2.41875c-0.36281,1.26313 0.01344,2.60688 0.9675,3.49375l27.09,26.9825c0.12094,0.18813 0.26875,0.37625 0.43,0.5375c0.06719,0.08063 0.13438,0.14781 0.215,0.215c0.20156,0.16125 0.41656,0.30906 0.645,0.43c0.06719,0.04031 0.14781,0.08063 0.215,0.1075c0.04031,0 0.06719,0 0.1075,0c0.06719,0.04031 0.14781,0.08063 0.215,0.1075c0.13438,0.04031 0.28219,0.08063 0.43,0.1075c0.36281,0.05375 0.71219,0.05375 1.075,0c0.06719,0 0.14781,0 0.215,0c0.29563,-0.06719 0.59125,-0.17469 0.86,-0.3225c0.45688,-0.22844 0.86,-0.56437 1.1825,-0.9675l27.305,-27.1975c1.37063,-1.37062 1.37063,-3.57437 0,-4.945c-1.37062,-1.37062 -3.57437,-1.37062 -4.945,0l-21.6075,21.6075v-74.175c0.04031,-0.99437 -0.36281,-1.94844 -1.075,-2.62031c-0.72562,-0.68531 -1.70656,-1.02125 -2.6875,-0.92719zM6.88,113.52v41.28c0,5.65719 4.66281,10.32 10.32,10.32h137.6c5.65719,0 10.32,-4.66281 10.32,-10.32v-41.28h-6.88v41.28c0,1.94844 -1.49156,3.44 -3.44,3.44h-137.6c-1.94844,0 -3.44,-1.49156 -3.44,-3.44v-41.28z"
                                        />
                                    </g>
                                </g>
                            </g>
                        </svg>
                        <span>檔案下載</span>
                    </a>
                </div>
            </div>
            <graybtn name="回上一頁" url="back" />
        </div>
    </div>
</template>

<script>
import API from "@/service/conference";
import Common from "@/common";
export default {
    name: "conferencedetail",
    components: {},
    props: {
        islogin: {
            type: Boolean
        },
        isallow: {
            type: Boolean
        }
    },
    data() {
        return {
            breadcrumbs: [
                {
                    url: "/",
                    title: "首頁"
                },
                {
                    title: "會刊及影音"
                },
                {
                    url: "/Conference/Healths",
                    title: "衛教資訊"
                }
            ],
            videoUrl: '',
            isYoutube: false,
            Type: window.location.pathname.split("/")[2],
            Location: window.location.hostname,
            showStyle: true,
            MediaType: "", //pdf or video
            MediaPDF: {
                // Id: "5d5d4a9b-f19a-474e-90c3-c8ee87c0d359",
                // Title: "青光眼濾泡手術相關眼內炎",
                // Introduction: "青光眼濾泡手術相關眼內炎解說",
                // Description:
                //   "<span style=\"font-family:Georgia, 'Times New Roman', Times, serif;font-size:medium;background-color:#ffffff;\">知們我務場使，斯本而，傳臺道提美部多一考大不電且路父了了當定演、物任技何們世，子長子難生愛因如，有於共可次我到極會居，演電養通友：立市人。有落我幾母！險光案，充的器觀！果心因的求政一所溫量，帶草修子表第最家在一不只級、經邊在國往爸之研你一族灣張性為包到客兒。</span>",
                // Content:
                //   "<span style=\"font-family:Georgia, 'Times New Roman', Times, serif;font-size:medium;background-color:#ffffff;\">知們我務場使，斯本而，傳臺道提美部多一考大不電且路父了了當定演、物任技何們世，子長子難生愛因如，有於共可次我到極會居，演電養通友：立市人。有落我幾母！險光案，充的器觀！果心因的求政一所溫量，帶草修子表第最家在一不只級、經邊在國往爸之研你一族灣張性為包到客兒。</span>",
                // DocumentFile:
                //   "https://retinasociety.blob.core.windows.net/health-education/5d5d4a9b-f19a-474e-90c3-c8ee87c0d359/3bb47828526641bdbf29a27a6b75e1f1.mp3",
                // Icon:
                //   "https://retinasociety.blob.core.windows.net/health-education/00000000-0000-0000-0000-000000000000/f75863803036496bbc17192f6c5f26a8.png",
                // Image:
                //   "https://retinasociety.blob.core.windows.net/health-education/00000000-0000-0000-0000-000000000000/86625a186b384aaba02f9425ccc6ed03.png",
                // PublishOn: "2019-08-05T15:06:40"
            },
            MediaVIDEO: {}
        };
    },
    methods: {
        getVideoUrl(url) {
            const vm = this; 
            if(url.indexOf('youtu') !== -1) {
                vm.isYoutube = true;
                let tmpUrl = url.replace('https://youtu.be/', '');
                vm.videoUrl = `https://www.youtube-nocookie.com/embed/${tmpUrl}`;                
            }
        },
        back() {
            const vm = this;
            if (vm.Type == "Journal") {
                location.href = "/Conference/Journals";
            } else if (vm.Type == "Detail") {
                location.href = "/HealthEducation";
            } else {
                location.href = "/Conference/DigitalVideo";
            }
            // history.back();
        },
        createpdf(path) {
            const vm = this;
            // console.log(path);
            let windowWidth = $("body").width();
            if (windowWidth > 767) {
                $("#mybook").wowBook({
                    container: window,
                    width: 1200,
                    maxHeight: 550,
                    pageNumbers: false,
                    toolbar: vm.islogin
                        ? "lastLeft, left,currentPage, right, lastRight, zoomin, zoomout, slideshow, fullscreen, thumbnails,share ,download"
                        : "lastLeft, left,currentPage, right, lastRight, zoomin, zoomout, slideshow, fullscreen, thumbnails,share",
                    pdf: path
                });
            } else {
                vm.showStyle = false;
            }
        },
        download(url) {
            const vm = this;
            if (!vm.islogin) {
                return false;
            }
            let Type = url
                .split("/")
                .pop()
                .split(".")
                .pop();
            Common.download(url, { type: Type });
        }
    },
    computed: {
        PDF() {
            let UrlString = location.href;
            let Url = new URL(UrlString);
            let Id = Url.searchParams.get("Id");
            let PDFs = [
                {
                    Id: "awdasd312",
                    Phase: "第五期",
                    Title:
                        "青光眼濾泡手術相關眼內炎南台灣醫學中心的回朔性病例分析",
                    Image: require("@/assets/dev/img2.png"),
                    StartDate: "2019-01-07",
                    EndDate: "2019-03-19",
                    Look:
                        "http://www.jingtenglong.com/Files/621d35220f5e4c82a9eded8e7ab824d3.pdf",
                    Download: "#"
                },
                {
                    Id: "234sdfhd",
                    Phase: "第四期",
                    Title:
                        "青光眼濾泡手術相關眼內炎南台灣醫學中心的回朔性病例分析",
                    Image: require("@/assets/dev/img3.png"),
                    StartDate: "2019-01-07",
                    EndDate: "2019-03-19",
                    Look:
                        "http://www.jingtenglong.com/Files/621d35220f5e4c82a9eded8e7ab824d3.pdf",
                    Download: "#"
                },
                {
                    Id: "asd455467f",
                    Phase: "第三期",
                    Title:
                        "青光眼濾泡手術相關眼內炎南台灣醫學中心的回朔性病例分析",
                    Image: require("@/assets/dev/img4.png"),
                    StartDate: "2019-01-07",
                    EndDate: "2019-03-19",
                    Look:
                        "http://www.jingtenglong.com/Files/621d35220f5e4c82a9eded8e7ab824d3.pdf",
                    Download: "#"
                },
                {
                    Id: "768dfgs344r",
                    Phase: "第二期",
                    Title:
                        "青光眼濾泡手術相關眼內炎南台灣醫學中心的回朔性病例分析",
                    Image: require("@/assets/dev/img3.png"),
                    StartDate: "2019-01-07",
                    EndDate: "2019-03-19",
                    Look:
                        "http://www.jingtenglong.com/Files/621d35220f5e4c82a9eded8e7ab824d3.pdf",
                    Download: "#"
                },
                {
                    Id: "das43654",
                    Phase: "第一期",
                    Title:
                        "青光眼濾泡手術相關眼內炎南台灣醫學中心的回朔性病例分析",
                    Image: require("@/assets/dev/img4.png"),
                    StartDate: "2019-01-07",
                    EndDate: "2019-03-19",
                    Look:
                        "http://www.jingtenglong.com/Files/621d35220f5e4c82a9eded8e7ab824d3.pdf",
                    Download: "#"
                }
            ];
            let myPDF = PDFs.filter(pdf => pdf.Id === Id);
            return myPDF[0];
        }
    },
    created() {
        const vm = this;
        if (
            vm.Type == "Journal" ||
            vm.Type == "Detail" ||
            vm.Type == "DigitalVideo" ||
            vm.Type == "HealthVideo" ||
            vm.Type == "ActivityProcess"
        ) {
            let Urlparams = Common.GetUrlParams("Id");
            if (vm.Type == "Journal") {
                API.getJournalDetail({ Id: Urlparams }).then(res => {
                    if (res.Ok) {
                        vm.MediaType = "pdf";
                        vm.MediaPDF = res.Data;
                        vm.createpdf(res.Data.DocumentFile);
                    }
                });
            } else if (vm.Type == "Detail") {
                API.getHealthEducationDetail({ Id: Urlparams }).then(res => {
                    if (res.Ok) {
                        if (res.Data.DocumentFile) {
                            let mediaType = res.Data.DocumentFile.split("/")
                                .pop()
                                .split(".")
                                .pop();
                            //   console.log(mediaType);
                            if (mediaType == "pdf") {
                                vm.MediaType = "pdf";
                                vm.MediaPDF = res.Data;
                                vm.createpdf(res.Data.DocumentFile);
                            } else {
                                vm.MediaVIDEO = res.Data;
                                vm.MediaType = "video";
                            }
                        }
                    }
                });
            } else if (vm.Type == "DigitalVideo" || vm.Type == "HealthVideo") {
                API.getVideoDetaill({ Id: Urlparams }).then(res => {
                    if (res.Ok) {
                        vm.MediaVIDEO = res.Data;
                        vm.$set(vm.MediaVIDEO, "DocumentFile", res.Data.Url);
                        vm.MediaType = "video";
                        vm.getVideoUrl(res.Data.Url);
                    }
                });
            } else {
                API.getProcessDetail({ Id: Urlparams }).then(res => {
                    if (res.Ok) {
                        vm.MediaType = "pdf";
                        vm.MediaPDF = res.Data;
                        vm.createpdf(res.Data.DocumentFile);
                    }
                });
            }
        } else {
            location.href = "/";
        }
    },
    mounted() {
        const vm = this;
        //鎖右鍵
        function iEsc() {
            return false;
        }
        function iRec() {
            return true;
        }
        function DisableKeys() {
            if (event.ctrlKey || event.shiftKey || event.altKey) {
                window.event.returnValue = false;
                iEsc();
            }
        }
        document.ondragstart = iEsc;
        document.onkeydown = DisableKeys;
        document.oncontextmenu = iEsc;
        if (typeof document.onselectstart != "undefined")
            document.onselectstart = iEsc;
        else {
            document.onmousedown = iEsc;
            document.onmouseup = iRec;
        }
        function DisableRightClick(qsyzDOTnet) {
            if (window.Event) {
                if (qsyzDOTnet.which == 2 || qsyzDOTnet.which == 3) iEsc();
            } else if (event.button == 2 || event.button == 3) {
                event.cancelBubble = true;
                event.returnValue = false;
                iEsc();
            }
        }
        //鎖右鍵
    },
    watch: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  scoped>
#conferencedetail .pdf {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    background-color: #fff;
    z-index: 99999;
}
#conferencedetail .pdf .top {
    position: absolute;
    top: 0;
    z-index: 1001;
    width: 100%;
    border-bottom: 1px solid #333;
    background-color: #fff;
}
#conferencedetail .pdf .top h2 {
    font-weight: normal !important;
    color: #ee8b59;
    width: 100%;
    text-align: center;
    padding: 15px 0;
}
#conferencedetail .pdf .top .title {
    display: flex;
    justify-content: center;
    align-items: center;
    /* margin-bottom: 15px; */
    padding: 15px 0;
    flex-wrap: wrap;
}
#conferencedetail .pdf .top .title .back {
    cursor: pointer;
}
#conferencedetail .pdf .top .title .name,
#conferencedetail .pdf .top .title .back {
    line-height: 1.2;
    font-size: 1.2rem;
    letter-spacing: 2px;
}
#conferencedetail .pdf .top .title .name {
    padding: 0 30px 0 10px;
}
#conferencedetail .note {
    text-align: center;
    margin-top: 30px;
    line-height: 1.5;
}
#conferencedetail .video_container {
    margin-top: 60px;
}
#conferencedetail .video_container .video_box {
    border: 8px solid #eee;
    padding: 30px 10px;
}
#conferencedetail .video_container .video_box .date {
    color: #666;
    padding: 10px 20px;
    letter-spacing: 2px;
    font-size: 1.1rem;
}
#conferencedetail .video_container .video_box .title {
    color: #666;
    font-size: 1.4rem;
    padding: 0 20px 20px;
    letter-spacing: 2px;
    line-height: 1.5;
    border-bottom: 1px solid #aaa;
    margin-bottom: 20px;
}
#conferencedetail .video_container .video_box .video {
    width: 75%;
    margin: auto;
    padding: 40px 0;
}
#conferencedetail .video_container .video_box .video video {
    width: 100%;
    /* height: 300px; */
}
#conferencedetail .video_container .video_box .remark {
    color: #666;
    letter-spacing: 2px;
    line-height: 1.5;
    padding: 20px;
}
#conferencedetail .video_container .video_box .download {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 20px auto;
    width: 165px;
}
@media screen and (max-width: 767px) {
    #conferencedetail .pdf .top {
        position: relative;
    }
    #conferencedetail .pdf .top .title {
        padding: 10px;
        justify-content: flex-start;
        align-items: flex-start;
        position: relative;
    }
    #conferencedetail .pdf .top .title .back {
        width: 5%;
        line-height: 1.5;
        margin-right: 5%;
    }
    #conferencedetail .pdf .top .title .name {
        padding: 0;
        width: 90%;
        line-height: 1.5;
        letter-spacing: 2px;
    }
    #conferencedetail .pdf .top .title .date {
        margin-top: 10px;
        padding-left: 10%;
    }
    #conferencedetail .video_container .video_box .date {
        padding: 10px 0;
    }
    #conferencedetail .video_container .video_box .title {
        padding: 0 0 20px;
    }
    #conferencedetail .video_container .video_box .video {
        padding: 20px 0 40px;
        width: 100%;
    }
    #conferencedetail .video_container .video_box .remark {
        padding: 10px 0;
    }
}
.video-container {
  position: relative;
  padding-bottom: 56.25%;
  padding-top: 30px;
  height: 0;
  overflow: hidden;
}

.video-container iframe,
.video-container object,
.video-container embed {
  position: absolute;

  top: 0;
  left: 0;

  width: 100%;

  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/journaldetail.vue